import { useAppDispatch, useAppSelector } from "../store";
import {
  getPatients,
  patients, patientsLoading
} from "../store/slices/user";

const useDoctorPatients = () => {
  const dispatch = useAppDispatch();
  const patientsData = useAppSelector(patients);
  const isPatientsLoading = useAppSelector(patientsLoading);
  const fetchPatients = () => dispatch(getPatients());

  return {
    patientsData,
    fetchPatients,
    isPatientsLoading
  };
};

export default useDoctorPatients;
